import { render } from "./FooterPa.vue?vue&type=template&id=1311c4d0&scoped=true"
import script from "./FooterPa.vue?vue&type=script&lang=js"
export * from "./FooterPa.vue?vue&type=script&lang=js"

import "./FooterPa.vue?vue&type=style&index=0&id=1311c4d0&lang=scss&scoped=true"

import exportComponent from "C:\\proyectos-alliances\\alliance.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1311c4d0"]])

export default __exports__